import { render, staticRenderFns } from "./CoronaDialog.vue?vue&type=template&id=e8081752&"
import script from "./CoronaDialog.vue?vue&type=script&lang=js&"
export * from "./CoronaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports